var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"canvas",staticClass:"powerpack-image"})])
}
var staticRenderFns = []

export { render, staticRenderFns }